import React from 'react'
// import { MODAL_MODE } from './CoAModalView'

const modal = {
  isOpen: false,
  open: () => {},
  close: () => { },
  submit: (): Promise<boolean> => { return Promise.resolve(false); }
  // mode: MODAL_MODE.ADD,

}

const ARFModalContext = React.createContext(modal)
ARFModalContext.displayName = 'ARFModalContext'

export default ARFModalContext
